module.exports = __webpack_public_path__ + "media/common/images/cta/mali-20bef46d060c533fcebaf719a264e3a1.webp";